/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CurrencyExchangeConfigurationQuerySourceCurrency extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("CurrencyExchangeConfigurationQuerySourceCurrency");
    }

    getFixupPrototypeFunction() { return CurrencyExchangeConfigurationQuerySourceCurrency.fixupPrototype; }

    static newInstance(model: Partial<CurrencyExchangeConfigurationQuerySourceCurrency>): CurrencyExchangeConfigurationQuerySourceCurrency {
        let obj = Object.assign(new CurrencyExchangeConfigurationQuerySourceCurrency(), model);
        CurrencyExchangeConfigurationQuerySourceCurrency.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CurrencyExchangeConfigurationQuerySourceCurrency>): CurrencyExchangeConfigurationQuerySourceCurrency {
        if (!model) return null;
        return CurrencyExchangeConfigurationQuerySourceCurrency.newInstance(<CurrencyExchangeConfigurationQuerySourceCurrency> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CurrencyExchangeConfigurationQuerySourceCurrency) {
        if (!obj) return;

        models.CurrencyExchangeConfigurationQuerySourceCurrency.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CurrencyExchangeConfigurationQuerySourceCurrency): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CurrencyExchangeConfigurationQuerySourceCurrency.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Source Currencies for Currency Exchange Configuration
     */
    source_currencies: Array<string>;

}
